import BaseEnumType from "../../common/base-enum-type";

const FirstDownStyles = Object.freeze({
    YardToGain: new BaseEnumType(-1, "Yard To Gain"),
    ZoneToGain: new BaseEnumType(1, "Zone To Gain")
});

export default FirstDownStyles;
